module.exports = __webpack_public_path__ + "static/img/bg-en.a7399769.png";